import styled from 'styled-components';

export const RadarChartContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    padding: 20px;
`;
